import React, {useEffect} from 'react';

import FormControl from '@mui/joy/FormControl';
import Grid from '@mui/joy/Grid';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';


export default function TrendBased(props) {
	const [sma, setSMA] = React.useState("");
	
	useEffect(() => {
		props.handleClick(props.activeCard && sma != "", sma);			
	}, [props.activeCard]);

	function handleChange(e, val) {
		setSMA(val);
		props.handleClick(props.activeCard && val != "", val);
	}

	return (
		
        <FormControl>
        	<Grid container xs={12}>
				<Select variant="solid" size="lg" disabled={!props.activeCard} placeholder="Choose your time frame" onChange={handleChange}>
					<Option value="SMA20">Short term (SMA20)</Option>
					<Option value="SMA50">Medium/long term (SMA50)</Option>
				</Select>
			</Grid>
		</FormControl>	    		
		
	)
}